import { render } from "./GenerateTag.vue?vue&type=template&id=bd808b9e"
import script from "./GenerateTag.vue?vue&type=script&lang=js"
export * from "./GenerateTag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__